import { FunctionComponent, useEffect, useState } from 'react';
import classnames from 'classnames';

import { createArrayWithProps } from 'utils/createArrayWithProps';

import { submitRating } from 'requests/articles';

import { useStateLocalStorage } from 'hooks/useStateLocalStorage';

import { LocalRatings, Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleRating: FunctionComponent<Props> = ({ article, translations }) => {
    const [hoveredStartIndex, setHoveredStarIndex] = useState<number>(0);
    const [ratedArticles, setRatedArticles] = useStateLocalStorage<LocalRatings[] | null>([], 'ratedArticles');
    const [alreadyRated, setAlreadyRated] = useState<number>(0);

    const avgScoreRounded = Math.round(article?.rating);
    const stars = createArrayWithProps(1, 5, ['children', '☆']);

    useEffect(() => {
        if (ratedArticles?.length === 0) return;
        const getRatedArticle = ratedArticles.find(({ id }) => id === article.id);

        if (getRatedArticle) {
            return setAlreadyRated(getRatedArticle.rating);
        }

        setAlreadyRated(0);
    }, [article]);

    const addRatingToLocalStorage = (articleId: string, rating: number) => {
        setRatedArticles(prevRating => [...prevRating, { id: articleId, rating }]);
        setAlreadyRated(rating);
    };


    return (
        <StyledComponent className="public-blogs-article-rating">
            <div className="rate">
                <span className="rate-title">
                    {alreadyRated ? translations?.ratedTitle : translations?.rateTitle}
                </span>
                <div className={classnames('rating-stars', alreadyRated && 'disable')}>
                    {stars.map((star, index) => (
                        <a
                            key={star.key}
                            className={classnames(
                                'star',
                                index < alreadyRated && 'active',
                                hoveredStartIndex > index && 'hovered',
                                (avgScoreRounded > index && !alreadyRated) && 'scored'
                            )}
                            onMouseEnter={() => setHoveredStarIndex(index + 1)}
                            onMouseLeave={() => setHoveredStarIndex(0)}
                            onClick={() => {
                                if (alreadyRated) return;
                                submitRating({
                                    id: article?.id,
                                    rating: star.key,
                                });
                                addRatingToLocalStorage(article?.id, star.key);
                            }}
                        >
                            {star.children}
                        </a>
                    ))}
                </div>
            </div>
            <div className="rating">
                {translations?.ratingTitle}
                {' '}
                <span className="rating-number">{article?.ratingDisplay ?? translations?.noRating}</span>
            </div>
            <div className="rate-count">
                {translations?.ratingsCountTitle}
                {' '}
                <span className="rate-count-number">{article?.ratingsCount}</span>
            </div>
        </StyledComponent>
    );
};

export default PublicBlogsArticleRating;
